import { ChatModuleType } from 'app/copied/models/ChatModules';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useCustomization from './useCustomization';
import useFeatureFlags from './useFeatureFlags';

export const useButtonMessages = () => {
  const customization = useCustomization();
  const { uiRefreshDisableRotatingMessages } = useFeatureFlags();
  const { data: helpCenter } = useFetchHelpCenter();

  const allMessages = customization?.open_button_messages?.length
    ? customization?.open_button_messages
    : [{ text: customization?.open_button_text || '', offline: false }];

  const isLiveChatAvailable = !!helpCenter?.modules.find(({ module_type }) => module_type === ChatModuleType.LiveChat);

  const onlineMessages = allMessages.filter(({ offline }) => !offline);
  const offlineMessages = allMessages.filter(({ offline }) => offline);

  const areAllMessagesTheSameKind = !onlineMessages.length || !offlineMessages.length;

  let messagesToUse = allMessages;

  if (isLiveChatAvailable) {
    if (areAllMessagesTheSameKind) {
      messagesToUse = allMessages;
    } else {
      if (helpCenter?.nurses_are_online) {
        messagesToUse = onlineMessages;
      } else {
        messagesToUse = offlineMessages;
      }
    }
  }

  if (uiRefreshDisableRotatingMessages && messagesToUse.length > 1) {
    return [messagesToUse[0]];
  }

  return messagesToUse;
};
